__turbopack_context__.v({
  "avatar": "review-module-scss-module__4payLa__avatar",
  "impression-wrapper": "review-module-scss-module__4payLa__impression-wrapper",
  "instructor-response-seo": "review-module-scss-module__4payLa__instructor-response-seo",
  "no-vertical-borders": "review-module-scss-module__4payLa__no-vertical-borders",
  "rating-container": "review-module-scss-module__4payLa__rating-container",
  "review-container": "review-module-scss-module__4payLa__review-container",
  "review-container-mobile-carousel": "review-module-scss-module__4payLa__review-container-mobile-carousel",
  "review-container-with-radius": "review-module-scss-module__4payLa__review-container-with-radius",
  "review-content-body": "review-module-scss-module__4payLa__review-content-body",
  "review-content-with-modal-trigger": "review-module-scss-module__4payLa__review-content-with-modal-trigger",
  "review-desktop-container": "review-module-scss-module__4payLa__review-desktop-container",
  "review-desktop-inline": "review-module-scss-module__4payLa__review-desktop-inline",
  "review-feedback-and-report-container": "review-module-scss-module__4payLa__review-feedback-and-report-container",
  "review-feedback-container": "review-module-scss-module__4payLa__review-feedback-container",
  "review-heading": "review-module-scss-module__4payLa__review-heading",
  "review-name-and-rating": "review-module-scss-module__4payLa__review-name-and-rating",
  "review-profile": "review-module-scss-module__4payLa__review-profile",
  "time-since": "review-module-scss-module__4payLa__time-since",
  "with-show-more-button": "review-module-scss-module__4payLa__with-show-more-button",
});
